module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE-Bold.21bea7da.eot";